import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { KIT_ACTIVE_LIST } from "../apiRoutes";

interface ActiveKIT {
  _id: string;
  kitName: string;
  kitType: string;
  description: string;
  createdBy: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

interface ActiveKITResponse {
  status: number;
  error: boolean;
  count: number;
  data: ActiveKIT[];
  message: string;
}

const fetchActiveKIT = async ({ data }: { data?: FieldValues }) => {
  const response = await axiosAuth.get<ActiveKITResponse>(KIT_ACTIVE_LIST, {
    params: data,
  });
  return response.data;
};

const useGetActiveKITQuery = (
  data?: FieldValues,
  queryParams?: UseQueryOptions<ActiveKITResponse, Error>
) =>
  useQuery<ActiveKITResponse, Error>({
    queryKey: ["active-kit", data],
    queryFn: () => fetchActiveKIT({ data }),
    ...queryParams,
  });

export default useGetActiveKITQuery;
